import React from 'react';
import { Tooltip } from '../../UiKit';
import { Info } from 'sushiweb/Icons';

export default function InfoButton({ details }) {
  return (
    <div
      css={`
        span:nth-child(2) {
          margin-left: -4rem;
        }
        span:nth-child(2)::after {
          margin-left: 3rem;
        }
      `}
    >
      <Tooltip
        position='top'
        border={false}
        title={<Info className='tw-mx-2' size='13' />}
        label={() => {
          return (
            <div className='tw-flex-col'>
              {details.map((text) => {
                return <div className='tw-text-100 tw-font-medium'>{text}</div>;
              })}
            </div>
          );
        }}
      />
    </div>
  );
}
